// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3tCM3","actionsCol":"EnrolledClinics_actionsCol__14JoX"};